// Ajitesh : 10/11/2023: BT-109135: Breeze eDIS implementation - Start
import { memo, useEffect, useState } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { BzButton, BzChip, BzDropdown, BzTabsContainer } from "../components";
import EdisAuthScrips from "../containers/EdisAuthScrips";
import EdisRevokeScrip from "../containers/EdisRevokeScrip";
import { useDispatch, useSelector } from "react-redux";
import { toastConfig } from "../redux/actions/toast";
import CopyToClipboard from "react-copy-to-clipboard";
import { getAppInfoData, getMappedMktSegIdFromApiExchangeName } from "../utils/global_functions";
import { APP_INFO_PARAMS, DEPOSITORY_CDSL, DEPOSITORY_NSDL, DISPLAY_EXCHANGE_NAME, EXCHANGE_NAME_API, MAPPED_MARKET_SEGMENT_ID, ORDER_PRODUCT_TYPES, SEGMENT_CASH, EDIS_REVOKE_NETNET_PAGE, EDIS_MODES, EDIS_REVOKE_DESCLAIMER } from "../utils/global_variables";
import { getEDISSummaryDetails, getTpin, updateEdisIsLoading } from "../redux/actions/edis";
import { useNavigate } from "react-router-dom";
import { LoginLoader } from "../containers/Login";
import config from '../config.json';
import { getInteropConfigurationDetails } from "../redux/actions/auth";

const Edis = ({ orderCartScripsForEdis = [], singleScripOrderData = null, productType = "", isAmo = false, mode = EDIS_MODES.EDIS_MODE_HAMBURGER, handleResponseForAmoSell, showOrderConfirmModal, orderData }) => {
    const dispatch = useDispatch();
    const userDpDetails = useSelector(state => state.auth.dpDetails);
    const userLoggedInData = useSelector(state => state.auth.objLoginSession.data);
    const edisSummaryDetails = useSelector(state => state.edis.edisSummaryDetails);
    const interopConfigDetails = useSelector(state => state.auth.interopConfig);
    const appInfo = useSelector(state => state.appInfo.appInfo);
    const userProfileDetails = useSelector(state => state.auth.userProfile);
    const isLoading = useSelector(state => state.edis.isLoading);
    const [activeTab, setActiveTab] = useState("authenticate");
    const [interopFlagStatus, setInteropFlagStatus] = useState(false);
    const [scripDetailsForGrid, setScripDetailsForGrid] = useState([]);
    const [revokeScripsForGrid, setRevokeScripsForGrid] = useState([]);
    const [edisConfig, setEdisConfig] = useState({});
    const [exchgAndMktSegData, setExchgAndMktSegData] = useState({});
    const [multiIsinEnabled, setMultiIsinEnabled] = useState(false);
    const [edisURL, setEdisURL] = useState("");
    const [edisRevokeURL, setEdisRevokeURL] = useState("");
    const navigate = useNavigate();
    //Vaibhav Singh:15-04-24:BT-107427: Taken redux from edis for loader reuse: Start
    useEffect(() => {
        dispatch(updateEdisIsLoading(false));
    }, [dispatch]);
    //Vaibhav Singh:15-04-24:BT-107427:  Taken redux from edis for loader reuse: End
    const getDefaultExchangeForEdis = () => {
        if (userLoggedInData && userLoggedInData.exchanges.length > 0) {
            for (const exchange of userLoggedInData.exchanges) {
                if (exchange === EXCHANGE_NAME_API.NSE_EQ_API) {
                    setExchgAndMktSegData({
                        ...exchgAndMktSegData,
                        exchangeName: DISPLAY_EXCHANGE_NAME.NSE_EXCHANGE_TEXT,
                        marketSegmentId: getMappedMktSegIdFromApiExchangeName(exchange)
                    });
                    break;
                }
                if (exchange === EXCHANGE_NAME_API.BSE_EQ_API) {
                    setExchgAndMktSegData({
                        ...exchgAndMktSegData,
                        exchangeName: DISPLAY_EXCHANGE_NAME.BSE_EXCHANGE_TEXT,
                        marketSegmentId: getMappedMktSegIdFromApiExchangeName(exchange)
                    });
                    break;
                }
                if (exchange === EXCHANGE_NAME_API.MCXSX_EQ_API) {
                    setExchgAndMktSegData({
                        ...exchgAndMktSegData,
                        exchangeName: DISPLAY_EXCHANGE_NAME.MSX_EXCHANGE_TEXT,
                        marketSegmentId: getMappedMktSegIdFromApiExchangeName(exchange)
                    });
                    break;
                }
            }
        }
    };

    // Function to make api call for EDIS summary only if product type is MTF or something else
    const getScripDataForEdis = () => {
        let mktSegmentId = interopFlagStatus ? MAPPED_MARKET_SEGMENT_ID.MAPPED_COMBINED_CASH : -1;
        let token = -1;
        let productTypeForApi = "";
        if (productType === ORDER_PRODUCT_TYPES.MTF) {
            productTypeForApi = ORDER_PRODUCT_TYPES.MTF;
        }
        const payload = {
            "mktSegmentId": mktSegmentId,
            "token": token,
            "productTypeForApi": productTypeForApi
        };
        dispatch(getEDISSummaryDetails(payload));
    };

    useEffect(() => {
        if (userLoggedInData) {
            getDefaultExchangeForEdis();
        }
    }, [userLoggedInData]);

    useEffect(() => {
        let isMultiIsinEnabled = getAppInfoData(APP_INFO_PARAMS.APP_MULTI_ISIN_NSDL);
        let url = getAppInfoData(APP_INFO_PARAMS.APP_EDIS_REQUEST_NEWNETNET_URL);
        let netNeturl = getAppInfoData(APP_INFO_PARAMS.APP_NETNET_URL);
        setEdisURL(url);
        setMultiIsinEnabled(isMultiIsinEnabled);
        setEdisRevokeURL(netNeturl + EDIS_REVOKE_NETNET_PAGE);
    }, [appInfo, setMultiIsinEnabled, setEdisURL]);

    useEffect(() => {
        if (interopConfigDetails.length > 0) {
            interopConfigDetails.forEach((elem) => {
                if (elem.nInteropPreferredCCL !== -1 &&
                    elem.nCombinedSegmentId === MAPPED_MARKET_SEGMENT_ID.MAPPED_COMBINED_CASH &&
                    elem.sSegment === SEGMENT_CASH
                ) {
                    setInteropFlagStatus(true);
                }
            });
        }
    }, [interopConfigDetails, setInteropFlagStatus]);

    useEffect(() => {
        if (userDpDetails.data && interopFlagStatus) {
            // TODO: Check how we can determine if user has multiIsInEnabled with Rajendra
            if ((userDpDetails.data.sDepository === DEPOSITORY_CDSL ||
                (userDpDetails.data.sDepository === DEPOSITORY_NSDL && multiIsinEnabled && multiIsinEnabled.toString().toUpperCase() === "TRUE")) &&
                userDpDetails.data.sDPId !== "" &&
                userDpDetails.data.nBeneficiaryAccountNumber !== ""
            ) {
                getScripDataForEdis();
            }
        }
    }, [userDpDetails, interopFlagStatus]);

    useEffect(() => {
        if (Object.keys(edisSummaryDetails).length) {
            // In order cart mode only show scrips that are in order cart and are pending for edis and not all edis scrips from api
            if (mode === EDIS_MODES.EDIS_MODE_ORDERCART) {
                // Need to filter again in case data is refreshed after eDIS flow is complete
                // Create a Set of isin codes from scrips in order cart
                const cartIsins = new Set(orderCartScripsForEdis.map(s => s.sISINCode));

                // Filter while removing duplicates:
                const seen = new Set();

                const updatedCartScrips = edisSummaryDetails.edis_summary.filter(edisScrip => {
                    const isin = edisScrip.sISINCode;

                    // Must exist in cart list:
                    if (!cartIsins.has(isin)) return false;

                    // Prevent duplicates:
                    if (seen.has(isin)) return false;
                    seen.add(isin);

                    return true;
                });

                setScripDetailsForGrid([...updatedCartScrips]);
            }
            else {
                // Need to filter edis summary data to check if scrips need EDIS flow else set data in redux
                const seen = new Set();
                const arrEdisSummaryScrips = edisSummaryDetails.edis_summary.filter(summaryScrip => summaryScrip.eDISRequestQty !== 0);
                const edisSummaryScrips = arrEdisSummaryScrips?.filter(summaryScrip => {
                    const duplicate = seen.has(summaryScrip.sISINCode);
                    seen.add(summaryScrip.sISINCode);
                    return !duplicate;
                });
                setScripDetailsForGrid([...edisSummaryScrips]);
            }
            setEdisConfig(...edisSummaryDetails.edis_config);
            const seen = new Set();
            const arrEdisSummaryScrips = edisSummaryDetails.edis_summary.filter(summaryScrip => summaryScrip.ApprovedQuantity !== 0);
            const edisSummaryScrips = arrEdisSummaryScrips?.filter(summaryScrip => {
                const duplicate = seen.has(summaryScrip.sISINCode);
                seen.add(summaryScrip.sISINCode);
                return !duplicate;
            });
            setRevokeScripsForGrid([...edisSummaryScrips]);
        }
    }, [edisSummaryDetails, mode]);

    const edisTabs = mode === EDIS_MODES.EDIS_MODE_HAMBURGER ? [
        {
            tabTitle: "Authenticate",
            tabKey: "authenticate"
        },
        /* Please DO NOT remove this comment until revoke functionality is ready*/
        ...(config.bIsProd === "false" ? [{ tabTitle: "Revoke", tabKey: "revoke" }] : []),
    ] : [
        {
            tabTitle: "Authenticate",
            tabKey: "authenticate"
        },
    ];


    const handleCopyDemat = () => {
        dispatch(toastConfig({ autoDismiss: true, show: true, message: 'Demat A/C no. copied to clipboard.' }));
    };

    const generateTpin = () => {
        let panNum = userProfileDetails.pan;
        let benfId = userProfileDetails.dp_details[0].clientBeneficiaryId;
        let dpId = userProfileDetails.dp_details[0].dpId;
        let dpType = userProfileDetails.dp_details[0].dpType;
        let reqObj = {
            "boid": benfId,
            "pan": panNum,
            "dpId": dpId,
            "dp_type": dpType
        };
        dispatch(getTpin(reqObj));
    };

    const refreshEdisDataAfterFlow = () => {
        getScripDataForEdis();
    };


    useEffect(() => {
        if (!interopConfigDetails.length) {
            dispatch(getInteropConfigurationDetails());
        }
    }, [interopConfigDetails]);

    return (
        <>
            <LoginLoader spinner={isLoading} />
            {/* Sumit G - 21-12-2023 */}
            {/* { mode === "normal" ? <Header /> : null } Ameersha N - 24-07-2024 -- As Header componenet is made common for all screens this code has been commented  */}
            <Container fluid className='p-0'>
                {
                    mode === EDIS_MODES.EDIS_MODE_HAMBURGER ? (
                        <Row className='background-heading bdr-btm px-5 g-0'>
                            <Col className='d-flex justify-content-start align-items-center'>
                                <div className='icon-16 icon-backward-arrow icon-dark me-3' onClick={() => navigate(-1)}></div>
                                <div className='font-medium font-size3 color-text pt-1'>eDIS Permission</div>
                            </Col>
                        </Row>
                    ) : null
                }
                <Row className={`g-0 py-2 bdr-btm ${mode === EDIS_MODES.EDIS_MODE_HAMBURGER ? `mt-2 px-3` : null}`}>
                    <Col className='d-flex justify-content-start align-items-center'>
                        <div className='font-medium font-size3 color-text'>Demat A/C No.</div>
                        {
                            userDpDetails.data ?
                                <>
                                    <div className='screen-dropdown ms-3'>
                                        <BzDropdown>
                                            <Dropdown.Toggle className='btn-default'>{userDpDetails?.data?.sDPId + userDpDetails?.data?.nBeneficiaryAccountNumber}</Dropdown.Toggle>
                                        </BzDropdown>
                                    </div>
                                    <CopyToClipboard text={userDpDetails?.data?.sDPId + userDpDetails?.data?.nBeneficiaryAccountNumber}>
                                        <div className='icon-16 icon-copy icon-dark ms-3' onClick={handleCopyDemat}></div>
                                    </CopyToClipboard>
                                </> : null
                        }
                    </Col>
                    {
                        userProfileDetails.hasOwnProperty("dp_details") && userProfileDetails?.dp_details[0]?.dpType === DEPOSITORY_CDSL ?
                            <Col md={3} className='d-flex justify-content-end align-items-center'>
                                <BzButton className='btn btn-sm btn-outline' onClick={generateTpin}>Generate TPIN</BzButton>
                            </Col> : null
                    }
                </Row>
            </Container>
            <Container fluid className={`p-0 ${mode === EDIS_MODES.EDIS_MODE_HAMBURGER ? `px-3` : null}`}>
                <Row className='g-0 py-2'>
                    <Col md={6}>
                        <div className='submenu-wrapper horizontal-scroll-wrap'>
                            {
                                edisTabs.length > 0 ? edisTabs.map(tab =>
                                    <BzChip key={tab.tabKey} onClick={() => setActiveTab(tab.tabKey)} className={`submenuItem ${activeTab === tab.tabKey ? "active" : null}`}>{tab.tabTitle}</BzChip>
                                ) : null
                            }
                        </div>
                    </Col>
                    {
                        Object.keys(edisSummaryDetails).length && activeTab === "authenticate" ? (
                            <Col md={6} className='d-flex justify-content-end align-items-center'>
                                <div className='d-flex flex-column justify-content-start'>
                                    <div className='font-medium font-size2 color-text'>Request Count</div>
                                    <div className='font-medium font-size2 color-text'>{edisSummaryDetails?.edis_config[0]?.UserTranCount}/{edisSummaryDetails?.edis_config[0]?.MaxTranCount}</div>
                                </div>
                                <div className='d-flex flex-column justify-content-start ms-5'>
                                    <div className='font-medium font-size2 color-text'>Authorized / Available Amount</div>
                                    <div className='font-medium font-size2 color-text'>{edisSummaryDetails?.edis_config[0]?.ValueUtilized}/{edisSummaryDetails?.edis_config[0]?.PerDayTransactionvalue}</div>
                                </div>
                            </Col>
                        ) : null
                    }
                </Row>
                {(activeTab === "revoke" && userDpDetails.data.sDepository === DEPOSITORY_CDSL) &&
                    <Row className='g-0 my-2'>
                        <Col>
                            <div className='font-regular font-size2 color-error'>{EDIS_REVOKE_DESCLAIMER}</div>
                        </Col>
                    </Row>
                }
            </Container>

            <BzTabsContainer>
                {
                    activeTab === "authenticate" ?
                        <EdisAuthScrips
                            scripDetailsForGrid={scripDetailsForGrid}
                            singleScripOrderData={singleScripOrderData}
                            orderCartScripsForEdis={orderCartScripsForEdis}
                            edisConfig={edisConfig}
                            exchgAndMktSegData={exchgAndMktSegData}
                            productType={productType}
                            isAmo={isAmo}
                            multiIsinEnabled={multiIsinEnabled}
                            mode={mode}
                            refreshEdisDataAfterFlow={refreshEdisDataAfterFlow}
                            edisURL={edisURL}
                            handleResponseForAmoSell={(response) => handleResponseForAmoSell(response)}
                            showOrderConfirmModal={showOrderConfirmModal}
                            orderData={orderData}
                        />
                        :
                        <EdisRevokeScrip
                            revokeScripsForGrid={revokeScripsForGrid}
                            edisRevokeURL={edisRevokeURL}
                            multiIsinEnabled={multiIsinEnabled}
                            refreshEdisDataAfterFlow={refreshEdisDataAfterFlow}
                        />
                }
            </BzTabsContainer>
        </>
    );
};

export default memo(Edis);
// Ajitesh : 10/11/2023: BT-109135: Breeze eDIS implementation - End